<template>
    <div>
        <div>
            <fieldset>
                <div class="row">
                    <legend>Frame Information</legend>
                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="columns small-4 medium-2 ">Order Type:</div>
            <div v-if="[2, 3, 4].includes(sampleobject.frameModel)" class="columns small-8 medium-10">Lens Only</div>
            <div v-else-if="sampleobject && sampleobject.uncut == false" class="columns small-8 medium-10">Sending In Frame</div>
            <div v-else class="columns small-8 medium-10">Uncut</div>

        </div>
        <div class="row">
            <div class="column small-12">
                <div class="row">
                    <div class="columns medium-2 small-4"> Frame: </div>
                    <div class="columns small-8 medium-10"> {{sampleobject.manufacturer}} {{sampleobject.model}} ({{sampleobject.color}}) </div>
                </div>
            </div>
        </div>
        <div v-if="sampleobject.upc" class="row">
            <div class="column small-12">
                <div class="row">
                    <div class="columns medium-2 small-4"> UPC: </div>
                    <div class="columns small-8 medium-10">{{ sampleobject.upc }}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="columns small-4 medium-2 "> Measures: </div>
            <div class="columns small-8 small-offset-4 medium-2 medium-offset-0 "> Temple: {{sampleobject.templeLength}} </div>
            <div class="columns small-8 small-offset-4 medium-2  medium-offset-0 "> A Box: {{sampleobject.aBox}} </div>
            <div class="columns small-8 small-offset-4 medium-2  medium-offset-0"> B Box: {{sampleobject.bBox}} </div>
            <div class="columns small-8 small-offset-4 medium-2  medium-offset-0 end"> Dbl: {{sampleobject.dbl}} </div>
        </div>

          <fieldset  v-if="sampleobject.uncut">
                <div class="row">
                    <legend>Cut / Uncut</legend>
                </div>
            </fieldset>

        <div class="row " v-if="sampleobject.uncut">
            
            <div class="columns small-12">
                <label for="allowUncut" class="uncut-smalltext"> <input checked="true" disabled="true" id="allowUncut" name="Allow uncut" type="checkbox" @change="toggleUncut()">
                    <strong>I would like to order uncut lenses.</strong>
                </label>
                <p class="uncut-smalltext">I would like to order uncut lenses. I understand that I will have to edge and mount these on my own, and confirm that my location has the ability and know-how to do so. I understand that I will not have the ability to have my lenses remade in the event that the process is done incorrectly. The Rx, Measurement, and Frame Information I have entered is correct and accurate.</p>
            </div>
        </div>

    </div>
</template>
<script>
export default {
  props: ["sampleobject"]
};
</script>
<style>
.frame-review-section {
  margin-top: 15px;
}

.uncut-smalltext {
  font-size: 11pt;
}
</style>
